import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }

import {onBeforeUnmount, ref} from "vue";
import TabsWrapper from "@/components/tabs/TabsWrapper.vue";
import TabItem from "@/components/tabs/TabItem.vue";
import {useGlobalStore} from "@/stores/GlobalStore";
import RecipientTab from "@/components/tabs/recipient/RecipientTab.vue";
import RecipientlistTab from "@/components/tabs/recipient/RecipientlistTab.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'Recipient',
  setup(__props) {

const globalStore = useGlobalStore();
const activeTab = ref<number>(0);

onBeforeUnmount(()=> {
  globalStore.gridStore = null
  globalStore.gridColumnStore = null
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('recipient.title')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TabsWrapper, { activeTab: activeTab.value }, {
        default: _withCtx(() => [
          _createVNode(TabItem, {
            title: _ctx.$t('recipient.tabs.recipient.title')
          }, {
            default: _withCtx(() => [
              _createVNode(RecipientTab)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(TabItem, {
            title: _ctx.$t('recipient.tabs.list.title')
          }, {
            default: _withCtx(() => [
              _createVNode(RecipientlistTab)
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["activeTab"])
    ])
  ], 64))
}
}

})